import { useShallow } from 'zustand/react/shallow';
import { useProductDetailsFilter } from '../../../../../../../services/modules/productDetails/productDetails.queries';
import { IProductDetailsGroupSectionParams } from '../../../../../../../services/modules/productDetails/productDetails.types';
import useGeneralSettingsStore from '../../../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import useProductDetailsStore from '../../../../../../../stores/ProductDetails/productDetails.store';
import { ProductDetailsOriginType } from '../../../../../../../stores/ProductDetails/productDetails.types';
import useIsAdminSeller from '../../../../../../../stores/ShowUnavailableProducts/hooks/useIsAdminSeller';
import { UseGetProductDetailsFiltersParams } from '../types/useGetProductDetailsFilters.types';

const useGetProductDetailsFilters = ({ allColorIds }: UseGetProductDetailsFiltersParams) => {
  const isAdminSeller = useIsAdminSeller();
  const { productGridParams, productDetailsModalState, relatedProductsFilterState, from } =
    useProductDetailsStore(
      useShallow((state) => ({
        productGridParams: state.productGridParams,
        productDetailsModalState: state.productDetailsModalState,
        relatedProductsFilterState: state.relatedProductsFilterState,
        from: state.from,
      })),
    );
  const catalogId = from?.type === ProductDetailsOriginType.CATALOG ? from.id : undefined;

  const { enableRelatedProductsFilterInProductDetails } = useGeneralSettingsStore(
    useShallow((state) => ({
      enableRelatedProductsFilterInProductDetails:
        state.generalSettings.enableRelatedProductsFilterInProductDetails,
    })),
  );

  const params: IProductDetailsGroupSectionParams = {
    isAdminSeller,
    productId: productDetailsModalState.productId,
    productColorId: productGridParams.productColorId,
    availability: productGridParams.availability,
    orderIds: productGridParams.orderIds,
    catalogId,
    allProductColorIds: allColorIds,
    filterByRelatedProducts:
      enableRelatedProductsFilterInProductDetails && relatedProductsFilterState,
  };
  const { data: filters, isLoading } = useProductDetailsFilter(params, {
    enabled: productGridParams.isFinishedOrder
      ? !!productGridParams.orderIds && !!productDetailsModalState.productId
      : !!productDetailsModalState.productId,
  });

  return {
    filters,
    isLoading,
  };
};

export default useGetProductDetailsFilters;
